import IMessage from "../../../../interface/IMessage";
import RenderUserMessage from "../renderMessageUser/renderMessageUser";
import React from "react";
import RenderMessageSystem from "../renderMessageSystem/renderMessageSystem";
import RenderBotMessage from "../renderBotMessage/renderBotMessage";

const RenderMessage = ({
  message,
}: {
  message: IMessage;
}): React.JSX.Element => {
  switch (message.sender) {
    case "bot":
      return <RenderBotMessage message={message} />;

    case "agent":
      return <RenderBotMessage message={message} />;

    case "user":
      return <RenderUserMessage message={message} />;

    default:
      return <RenderMessageSystem message={message} />;
  }
};

const RenderMessageBox = ({
  message,
}: {
  message: IMessage;
}): React.JSX.Element => {
  return <RenderMessage message={message} />;
};

export default RenderMessageBox;
